import React from 'react';

import { Outlet } from 'react-router-dom';

const KitchenItemRequestContent = () => {
  return <Outlet />;
};

export default KitchenItemRequestContent;
